'use client';

import { useQuery } from '@tanstack/react-query';
import { usePathname, useRouter } from 'next/navigation';
import { useTransition } from 'react';
import { Field, SelectField } from 'ui';
import { qsStringify } from 'utils';
import { fetchSubregions } from '~/api/address';
import { TradeInEventsPageParams } from '~/app/(default)/events/page';

export default function TradeInEventsFilters({
  partners,
  searchParams,
}: {
  partners: string[];
  searchParams: TradeInEventsPageParams;
}) {
  const { data: subregions } = useQuery(['regions', 'US'], () =>
    fetchSubregions('US'),
  );

  const pathname = usePathname();
  const router = useRouter();

  const [isPending, startTransition] = useTransition();

  const {
    partner: filteredPartner = '',
    state: filteredState = '',
    start_date: startDate = '',
  } = searchParams;

  return (
    <>
      <div className="mb-6 grid grid-cols-4 gap-x-4">
        <SelectField
          disabled={isPending}
          containerClassName="col-span-3"
          label="Partner"
          onChange={e => {
            startTransition(() =>
              router.push(
                pathname +
                  qsStringify({
                    ...searchParams,
                    partner: e.target.value || null,
                    page: null,
                  }),
                {
                  scroll: false,
                },
              ),
            );
          }}
          value={filteredPartner ?? ''}
        >
          <option value="">All Partners</option>
          {partners.map((partner, index) => (
            <option key={index} value={partner}>
              {partner}
            </option>
          ))}
        </SelectField>

        <SelectField
          disabled={isPending}
          label="State"
          onChange={e =>
            startTransition(() =>
              router.push(
                pathname +
                  qsStringify({
                    ...searchParams,
                    state: e.target.value || null,
                    page: null,
                  }),
                {
                  scroll: false,
                },
              ),
            )
          }
          value={filteredState ?? ''}
        >
          <option value="">All States</option>
          {subregions?.map(subregion => (
            <option key={subregion.id} value={subregion.id.toLowerCase()}>
              {subregion.id}
            </option>
          ))}
        </SelectField>

        <Field
          disabled={isPending}
          containerClassName="col-span-2"
          label="Start Date"
          type="date"
          value={startDate as string}
          onChange={e =>
            startTransition(() =>
              router.push(
                pathname +
                  qsStringify({
                    ...searchParams,
                    start_date: e.target.value || null,
                    page: null,
                  }),
                {
                  scroll: false,
                },
              ),
            )
          }
        />
      </div>
    </>
  );
}
